import { render, staticRenderFns } from "./BsMaTreat.vue?vue&type=template&id=789fc051&scoped=true"
import script from "./BsMaTreat.vue?vue&type=script&lang=js"
export * from "./BsMaTreat.vue?vue&type=script&lang=js"
import style0 from "./BsMaTreat.vue?vue&type=style&index=0&id=789fc051&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789fc051",
  null
  
)

export default component.exports